export default __webpack_public_path__ + "static/media/holiday-club.ecf0dd9f.svg";